export default {
  label: 'Percepe taxa de serviciu la comenzile la masă',
  description: 'Comenzile la masă nu plătesc taxa de serviciu dacă această opțiune nu este activată.',
  no_fee: 'Restaurantul tău nu percepe taxă de serviciu, așa că nici comenzile la masă nu plătesc una.',
  partner_default_on: 'Implicit partener: activat',
  partner_default_off: 'Implicit partener: dezactivat',
  toasts: {
    on: 'Comenzile la masă plătesc acum taxa de serviciu',
    off: 'Comenzile la masă nu mai plătesc taxa de serviciu',
    error: 'Nu s-a salvat. Încercați din nou.',
  },
};
